export enum COUNTRY_CODE {
  AT = 'AT',
  CH = 'CH',
  CZ = 'CZ',
  DE = 'DE',
  FR = 'FR',
  NL = 'NL',
  SK = 'SK',
  US = 'US',
  VN = 'VN',
}
